import WC from "../common/WebcomponentCreator"
import "../css/buttonSelect.css";
import styles from "styles-to-js-loader/styles";

class ButtonSelectBase extends WC {
    // static get observedAttributes() {
    //     return super.observedAttributes.concat("selected");
    // }
    constructor() {
        const template = document.createElement("form");
        template.setAttribute("class", "button-selection-container");
        super(template, { shadowMode: "closed" });
        this.getShadow().appendChild(styles.get());
        this.template = template;
        //TODO eventlistner for filling out buttons
        this.buttons = [];
    }

    setUpButtons(options = [{
        text: "Hej",
        value: 1,
        selected: true,
        id: "hej1"
    }]) {
        for (let i = 0; i < options.length; i++) {
            var doIt = function (setSelected) {
                var button = document.createElement("button");
                button.value = options[i].value;
                var id = ""
                if (options[i].id) {
                    button.setAttribute("id", options[i].id);
                    id = options[i].id;
                }
                else {
                    id = options[i].text + options[i].value;
                    button.setAttribute("id", id);
                }

                var label = document.createElement("label");
                label.innerHTML = options[i].text;
                label.setAttribute("for", id);
                button.appendChild(label);
                button.addEventListener("click", e => {
                    e.preventDefault();
                    setSelected(options[i].value);
                });
                options[i].button = button;
            };
            doIt(this.setSelected.bind(this));
            this.addCheckMark(options[i].button);
            this.template.appendChild(options[i].button);
        }
        this.buttons = options;
        this.setSelected(this.buttons[0].value);
    }
    addCheckMark(btn) {
        var checkmark = document.createElement("div");
        checkmark.setAttribute("class", "checkmark");
        var checkmark_circle = document.createElement("div");
        checkmark_circle.setAttribute("class", "checkmark_circle");
        var checkmark_stem = document.createElement("div");
        checkmark_stem.setAttribute("class", "checkmark_stem");
        var checkmark_kick = document.createElement("div");
        checkmark_kick.setAttribute("class", "checkmark_kick");

        checkmark.appendChild(checkmark_circle);
        checkmark.appendChild(checkmark_stem);
        checkmark.appendChild(checkmark_kick);
        var label = btn.getElementsByTagName("label")[0];
        btn.insertBefore(checkmark, label);
        // btn.appendChild(checkmark);
    }
    addTitle(text) {
        var label = document.createElement("label");
        label.setAttribute("for", "button-selection-container");
        label.innerHTML = text;
        this.template.appendChild(label);
    }
    setSelected(val) {
        for (var i = 0; i < this.buttons.length; i++) {
            var button = this.buttons[i].button;
            if (button.value === val || button.value === val.toString()) {
                button.setAttribute("selected", true);
            }
            else {
                button.removeAttribute("selected");
            }
        }
        var event = new Event("change");
        this.dispatchEvent(event);
    }
    getSelected() {
        var val;
        for (var i = 0; i < this.buttons.length; i++) {
            var button = this.buttons[i].button;
            if (button.getAttribute("selected")) {
                val = button.value;
            }
        }
        return val;
    }
    getSelectedText() {
        var text;
        for (var i = 0; i < this.buttons.length; i++) {
            var button = this.buttons[i].button;
            if (button.getAttribute("selected")) {
                var label = button.getElementsByTagName("label")[0];
                text = label.innerHTML;
            }
        }
        return text;
    }
    get value() {
        return this.getSelected();
    }
}

if (!customElements.get('button-select')) {
if (!customElements.get("button-select")) {
        WC.define("button-select", ButtonSelectBase);
}
}
